import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

import CustomTag from '../customtag';

export default class ListTag extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            show_input_field: props.default_input,
            new_tag: null,
        };
    }

    onEnterInput = e => {
        const { new_tag } = this.state;
        if (new_tag && new_tag.trim().length > 0 && e.keyCode === 13) {
            this.props.addNewTag(new_tag.trim());
            this.setState({ new_tag: null });
        }
    };

    showInputField = () => {
        const { default_input } = this.props;
        if (!default_input) {
            this.setState({ show_input_field: true });
        }
    };

    hideInputField = () => {
        const { default_input } = this.props;
        if (!default_input) {
            this.setState({ show_input_field: false });
        }
    };

    onChangeInput = e => {
        this.setState({ new_tag: e.target.value });
    };

    render() {
        const { default_input, container_class, list_container_class, tag_outer_container_class, tag_container_class, disable, input_container_class, input_class, size, placeholder, list, deleteTag } = this.props;
        const { show_input_field, new_tag } = this.state;

        return (
            <div className={container_class} style={{ minHeight: '20px' }} onDoubleClick={this.showInputField}>
                <div className={list_container_class}>
                    {
                        list && list.map((item, list_index) => {
                            return (
                                <CustomTag key={list_index} container_class={tag_outer_container_class} tag_container_class={tag_container_class} disable={disable} label={item} onClick={deleteTag.bind(this, list_index)} />
                            )
                        })
                    }
                </div>
                {
                    show_input_field &&
                    <div className={input_container_class}>
                        <Input autoFocus={!default_input} size={size} className={input_class} placeholder={placeholder} value={new_tag} onKeyDown={this.onEnterInput} onBlur={this.hideInputField} onChange={this.onChangeInput} />
                    </div>
                }
            </div>
        );
    }
}

ListTag.propTypes = {
    default_input: PropTypes.bool,
    container_class: PropTypes.string,
    list_container_class: PropTypes.string,
    tag_outer_container_class: PropTypes.string,
    tag_container_class: PropTypes.string,
    input_container_class: PropTypes.string,
    input_class: PropTypes.string,
    disable: PropTypes.bool,
    list: PropTypes.array,
    deleteTag: PropTypes.func,
    placeholder: PropTypes.string,
    size: PropTypes.oneOf(['large', 'small', 'default']),
    addNewTag: PropTypes.func,
};

ListTag.defaultProps = {
    default_input: false,
    container_class: "ori-flex-row ori-flex-wrap",
    list_container_class: "ori-flex-row ori-flex-wrap ori-tb-pad-3",
    input_container_class: "ori-animated ori-zoom-in ori-lr-pad-5 ori-tb-pad-5",
    input_class: "ori-border-radius-15 ori-lr-pad-10 ori-font-xs",
    disable: false,
    placeholder: "add new tag",
    size: "small",
    list: [],
};



// WEBPACK FOOTER //
// ./src/components/listtag/index.js